var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatPump(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16{fill:none;}.cls-2{clip-path:url(#clippath-8);}.cls-3{clip-path:url(#clippath-7);}.cls-4{clip-path:url(#clippath-6);}.cls-5{clip-path:url(#clippath-9);}.cls-6{clip-path:url(#clippath-5);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-4);}.cls-9{clip-path:url(#clippath-2);}.cls-10{clip-path:url(#clippath-1);}.cls-11{isolation:isolate;}.cls-17{fill:#025a66;}.cls-18{fill:#025661;}.cls-19{fill:#025864;}.cls-20{fill:#025763;}.cls-21{fill:#014d57;}.cls-22{fill:#01424a;}.cls-23{fill:#01545f;}.cls-24{fill:#01444d;}.cls-25{fill:#013b43;}.cls-26{fill:#014852;}.cls-27{fill:#01464f;}.cls-28{fill:#014f5a;}.cls-29{fill:#01515c;}.cls-30{fill:#014b54;}.cls-31{fill:#013f48;}.cls-32{fill:#013d45;}.cls-33{fill:#eee;}.cls-34{fill:#737d7d;}.cls-35{fill:#656e6e;}.cls-36{fill:#999;}.cls-37{fill:#8a8a8a;}.cls-38{fill:#b5b5b5;}.cls-39{fill:#b7b7b7;}.cls-40{fill:#b8b8b8;}.cls-41{fill:#9e9e9e;}.cls-42{fill:#b9b9b9;}.cls-43{fill:#c2c2c2;}.cls-44{fill:#b3b3b3;}.cls-45{fill:#8f8f8f;}.cls-46{fill:#c1c1c1;}.cls-47{fill:#858585;}.cls-48{fill:#bbb;}.cls-49{fill:#bfbfbf;}.cls-50{fill:#bdbdbd;}.cls-51{fill:#ccc;}.cls-52{fill:#c7c7c7;}.cls-53{fill:#dedede;}.cls-54{fill:#adadad;}.cls-55{fill:#c5c5c5;}.cls-56{fill:#c6c6c6;}.cls-57{fill:#a8a8a8;}.cls-58{fill:#3d8b95;}.cls-59{fill:#a3a3a3;}.cls-60{fill:#949494;}.cls-61{fill:#a2b0b1;}.cls-12{clip-path:url(#clippath-13);}.cls-13{clip-path:url(#clippath-12);}.cls-14{clip-path:url(#clippath-11);}.cls-15{clip-path:url(#clippath-10);}.cls-16{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.43,1.17l13.98,8.13c-.34-.2-.81-.17-1.33.13l-13.98-8.13c.52-.3.99-.33,1.33-.13Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.84,97.28l-13.98-8.13c-.34-.19-.54-.61-.54-1.2l13.98,8.13c0,.59.21,1,.54,1.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.16,49.05l-13.98-8.13c0-1.18.82-2.62,1.85-3.22l13.98,8.13c-1.03.59-1.86,2.04-1.85,3.22Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.31,79.47c8.81-5.09,15.93-17.41,15.9-27.54.25.15.5.29.75.44.03,10.12-7.09,22.45-15.9,27.54-.23-.13-.53-.31-.75-.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m73.21,51.93c-.01-5.03-1.79-8.57-4.65-10.23l.75.44c2.86,1.66,4.64,5.2,4.65,10.23-.25-.15-.5-.29-.75-.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.97,80.58c2.9,1.69,6.92,1.45,11.35-1.11l.75.44c-4.43,2.56-8.45,2.8-11.35,1.11-.23-.13-.53-.31-.75-.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.96,59.59c0-.85-.3-1.45-.79-1.74l.75.44c.49.28.79.88.79,1.74-.25-.15-.5-.29-.75-.44.25.15.5.29.75.44,0,1.71-1.2,3.79-2.69,4.65l-.75-.44c1.49-.86,2.69-2.94,2.69-4.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.35,64.43c.49.29,1.17.24,1.93-.19l.75.44c-.75.43-1.43.48-1.93.19-.23-.13-.53-.31-.75-.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.17,57.85l.75.44c-.49-.28-1.17-.25-1.92.19l-.75-.44c.75-.43,1.43-.47,1.92-.19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.1,64.87l-.75-.44c-.48-.28-.78-.88-.79-1.73,0-1.71,1.2-3.8,2.69-4.67l.75.44c-1.49.86-2.7,2.95-2.69,4.67,0,.85.3,1.45.79,1.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.56,41.7l.75.44c-2.9-1.69-6.92-1.45-11.35,1.11l-.75-.44c4.43-2.56,8.45-2.8,11.35-1.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.49,40.11l.75.44c-3.14-1.82-7.48-1.57-12.28,1.2l-.75-.44c4.8-2.77,9.14-3.03,12.28-1.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.72,81.02l-.75-.44c-2.86-1.66-4.64-5.2-4.65-10.23-.03-10.12,7.09-22.45,15.9-27.54l.75.44c-8.81,5.09-15.93,17.41-15.9,27.54.01,5.03,1.79,8.57,4.65,10.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.79,82.61l-.75-.44c-3.1-1.8-5.02-5.63-5.03-11.07-.03-10.95,7.67-24.29,17.2-29.79l.75.44c-9.53,5.5-17.23,18.84-17.2,29.79.02,5.44,1.94,9.27,5.03,11.07Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heat_pump"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heat_pump-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.45,98.86L.62,78.57c-.72-.41-.7-1.45.03-1.83l60.08-31.42c.28-.14.6-.16.89-.03l37.73,16.12c.79.34.86,1.43.11,1.86l-61.98,35.59c-.32.18-.71.18-1.03,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "51.01 87.62 51.01 89.58 39.09 96.46 39.09 94.51 51.01 87.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "39.09 96.46 25.11 88.34 25.1 86.38 39.09 94.51 39.09 96.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "39.09 94.51 25.1 86.38 37.02 79.5 51.01 87.62 39.09 94.51"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "96.28 61.84 96.29 63.8 84.37 70.68 84.36 68.72 96.28 61.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "84.37 70.68 70.38 62.55 70.38 60.6 84.36 68.72 84.37 70.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "84.36 68.72 70.38 60.6 82.3 53.72 96.28 61.84 84.36 68.72"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m98.08,9.42l-13.98-8.13s.08-.05.12-.07l13.98,8.13s-.08.04-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m98.21,9.36l-13.98-8.13c.12-.06.24-.11.35-.14l13.98,8.13c-.11.03-.23.08-.35.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m98.56,9.22l-13.98-8.13c.09-.03.19-.04.28-.05l13.98,8.13c-.09,0-.18.02-.28.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m98.84,9.17l-13.98-8.13c.08,0,.17,0,.24,0l13.98,8.13c-.08-.01-.16-.02-.24,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m99.08,9.18l-13.98-8.13c.08.01.16.03.23.07l13.98,8.13c-.07-.03-.15-.05-.23-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m99.31,9.25l-13.98-8.13s.07.03.1.05l13.98,8.13s-.06-.03-.1-.05"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m33.84,97.28l-13.98-8.13c-.34-.19-.54-.61-.54-1.2l13.98,8.13c0,.59.21,1,.54,1.2"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "33.29 96.08 19.31 87.96 19.18 40.93 33.16 49.05 33.29 96.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "35.01 45.84 21.03 37.71 84.1 1.3 98.08 9.42 35.01 45.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m98.08,9.42c1.03-.59,1.87-.11,1.87,1.07l.13,47.03c0,1.18-.83,2.63-1.86,3.22l-63.07,36.41c-1.03.59-1.86.11-1.86-1.07l-.13-47.03c0-1.18.82-2.62,1.85-3.22L98.08,9.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m33.16,49.05l-13.98-8.13c0-.09,0-.17.01-.26l13.98,8.13c0,.09-.01.17-.01.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m33.17,48.79l-13.98-8.13c.01-.14.04-.28.07-.42l13.98,8.13c-.03.14-.06.28-.07.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m33.24,48.38l-13.98-8.13c.03-.12.06-.24.1-.37l13.98,8.13c-.04.12-.08.24-.1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m33.35,48.01l-13.98-8.13c.04-.12.09-.24.14-.36l13.98,8.13c-.05.12-.1.24-.14.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m33.48,47.65l-13.98-8.13c.06-.13.12-.25.19-.37l13.98,8.13c-.07.12-.13.25-.19.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m33.67,47.28l-13.98-8.13c.08-.15.17-.29.27-.43l13.98,8.13c-.1.14-.19.28-.27.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m33.94,46.85l-13.98-8.13c.3-.42.67-.78,1.07-1.01l13.98,8.13c-.4.23-.77.59-1.07,1.01"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "99.64 18.82 99.65 22.22 84.37 31.04 86.98 26.12 99.64 18.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m58.07,79.91l-.75-.44c1.87-1.08,3.66-2.49,5.33-4.13l.75.44c-1.67,1.64-3.46,3.05-5.33,4.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m63.4,75.78l-.75-.44c.6-.59,1.18-1.21,1.74-1.86l.75.44c-.56.65-1.14,1.27-1.74,1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m65.14,73.92l-.75-.44c.44-.51.88-1.04,1.29-1.58l.75.44c-.42.54-.85,1.07-1.29,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m66.43,72.35l-.75-.44c.36-.47.72-.95,1.06-1.44l.75.44c-.34.49-.7.97-1.06,1.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m67.49,70.91l-.75-.44c.32-.45.62-.91.92-1.38l.75.44c-.3.47-.61.93-.92,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m68.42,69.53l-.75-.44c.28-.44.56-.89.82-1.35l.75.44c-.27.46-.54.91-.82,1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m69.24,68.18l-.75-.44c.26-.44.51-.89.75-1.34l.75.44c-.24.45-.49.9-.75,1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m69.99,66.84l-.75-.44c.24-.45.47-.9.69-1.36l.75.44c-.22.46-.45.91-.69,1.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m70.68,65.48l-.75-.44c.22-.46.43-.92.63-1.38l.75.44c-.2.46-.41.93-.63,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m71.31,64.1l-.75-.44c.21-.47.4-.95.59-1.43l.75.44c-.18.48-.38.96-.59,1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m71.9,62.67l-.75-.44c.19-.5.37-1,.54-1.51l.75.44c-.17.5-.35,1.01-.54,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m72.44,61.16l-.75-.44c.18-.54.35-1.08.5-1.63l.75.44c-.15.54-.32,1.08-.5,1.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m72.93,59.53l-.75-.44c.17-.61.32-1.22.45-1.83l.75.44c-.13.61-.28,1.22-.45,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m73.38,57.7l-.75-.44c.16-.74.28-1.48.38-2.21l.75.44c-.09.73-.22,1.47-.38,2.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m73.76,55.49l-.75-.44c.14-1.06.21-2.1.2-3.12-.01-5.03-1.79-8.57-4.65-10.23l.75.44c2.86,1.66,4.64,5.2,4.65,10.23,0,1.02-.07,2.06-.2,3.12"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m73.76,55.49l-.75-.44c.14-1.06.21-2.1.2-3.12-.01-5.03-1.79-8.57-4.65-10.23l.75.44c2.86,1.66,4.64,5.2,4.65,10.23,0,1.02-.07,2.06-.2,3.12"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m46.72,81.02l-.75-.44s.06.03.09.05l.75.44s-.06-.03-.09-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m46.8,81.07l-.75-.44c.26.15.53.28.8.39l.75.44c-.28-.12-.54-.25-.8-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m47.61,81.46l-.75-.44c.27.11.55.21.84.3l.75.44c-.29-.08-.57-.18-.84-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m48.45,81.76l-.75-.44c.29.08.59.15.9.21l.75.44c-.31-.05-.6-.12-.9-.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m49.34,81.96l-.75-.44c.31.05.64.09.96.11l.75.44c-.33-.02-.65-.06-.96-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m50.31,82.08l-.75-.44c.34.02.7.02,1.06,0l.75.44c-.36.02-.71.01-1.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m51.36,82.08l-.75-.44c.39-.02.78-.06,1.19-.12l.75.44c-.4.06-.8.1-1.19.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m52.55,81.97l-.75-.44c.46-.07.93-.17,1.4-.3l.75.44c-.48.13-.94.23-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m53.95,81.67l-.75-.44c.61-.17,1.24-.38,1.88-.65l.75.44c-.64.27-1.27.48-1.88.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m55.83,81.02l-.75-.44c.73-.3,1.48-.67,2.23-1.11l.75.44c-.76.44-1.5.81-2.23,1.11"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m58.02,64.68l-.75-.44c.32-.18.62-.42.9-.7l.75.44c-.28.28-.59.52-.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m58.93,63.98l-.75-.44c.1-.1.2-.2.29-.31l.75.44c-.1.11-.19.21-.29.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m59.22,63.66l-.75-.44c.07-.09.15-.17.22-.27l.75.44c-.07.09-.14.18-.22.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m59.44,63.4l-.75-.44c.06-.08.12-.16.18-.24l.75.44c-.06.08-.12.16-.18.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m59.62,63.16l-.75-.44c.05-.08.11-.15.16-.23l.75.44c-.05.08-.1.16-.16.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m59.77,62.92l-.75-.44c.05-.07.09-.15.14-.23l.75.44c-.04.08-.09.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m59.91,62.7l-.75-.44c.04-.07.09-.15.13-.23l.75.44c-.04.08-.08.15-.13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m60.04,62.47l-.75-.44c.04-.08.08-.15.12-.23l.75.44c-.04.08-.08.15-.12.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m60.15,62.24l-.75-.44c.04-.08.07-.16.11-.23l.75.44c-.03.08-.07.16-.11.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m60.26,62.01l-.75-.44c.03-.08.07-.16.1-.24l.75.44c-.03.08-.06.16-.1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m60.36,61.77l-.75-.44c.03-.08.06-.17.09-.25l.75.44c-.03.08-.06.17-.09.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m60.45,61.51l-.75-.44c.03-.09.06-.18.08-.27l.75.44c-.03.09-.05.18-.08.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m60.54,61.24l-.75-.44c.03-.1.05-.21.08-.31l.75.44c-.02.1-.05.21-.08.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m60.61,60.93l-.75-.44c.03-.13.05-.25.06-.37l.75.44c-.02.12-.04.25-.06.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m60.68,60.55l-.75-.44c.02-.18.04-.36.03-.53,0-.85-.3-1.45-.79-1.74l.75.44c.49.28.79.88.79,1.74,0,.17-.01.35-.03.53"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m56.1,64.87l-.75-.44s0,0,.01,0l.75.44s0,0-.01,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m56.11,64.88l-.75-.44s.09.05.14.07l.75.44s-.09-.04-.14-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m56.25,64.94l-.75-.44s.09.04.14.05l.75.44s-.1-.03-.14-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m56.39,64.99l-.75-.44s.1.03.15.03l.75.44c-.05,0-.1-.02-.15-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m56.54,65.03l-.75-.44c.05,0,.11.02.16.02l.75.44c-.06,0-.11,0-.16-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m56.71,65.05l-.75-.44c.06,0,.12,0,.18,0l.75.44c-.06,0-.12,0-.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m56.88,65.05l-.75-.44c.07,0,.13,0,.2-.02l.75.44c-.07.01-.14.02-.2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m57.09,65.03l-.75-.44c.08-.01.16-.03.24-.05l.75.44c-.08.02-.16.04-.24.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m57.32,64.98l-.75-.44c.1-.03.21-.06.32-.11l.75.44c-.11.05-.21.08-.32.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m57.64,64.87l-.75-.44c.12-.05.25-.11.38-.19l.75.44c-.13.07-.26.14-.38.19"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m58.01,58.47l-.75-.44c.13-.07.25-.14.38-.19l.75.44c-.12.05-.25.11-.38.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m58.38,58.29l-.75-.44c.11-.04.21-.08.32-.11l.75.44c-.1.03-.21.06-.32.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m58.7,58.18l-.75-.44c.08-.02.16-.04.24-.05l.75.44c-.08.01-.16.03-.24.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m58.94,58.13l-.75-.44c.07-.01.14-.02.2-.02l.75.44c-.07,0-.13,0-.2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m59.14,58.11l-.75-.44c.06,0,.12,0,.18,0l.75.44c-.06,0-.12,0-.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m59.31,58.11l-.75-.44c.06,0,.11,0,.16.02l.75.44c-.05,0-.11-.02-.16-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m59.48,58.13l-.75-.44c.05,0,.1.02.15.03l.75.44s-.1-.03-.15-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m59.63,58.16l-.75-.44s.1.03.14.05l.75.44s-.09-.04-.14-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m59.77,58.21l-.75-.44s.09.04.14.07l.75.44s-.09-.05-.14-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m59.91,58.28l-.75-.44s0,0,.01,0l.75.44s0,0-.01,0"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m56.1,64.87l-.75-.44c-.48-.28-.78-.88-.79-1.73,0-.17.01-.35.03-.53l.75.44c-.02.18-.03.35-.03.53,0,.85.3,1.45.79,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m55.35,62.61l-.75-.44c.02-.12.04-.25.06-.37l.75.44c-.03.13-.05.25-.06.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m55.41,62.24l-.75-.44c.02-.1.05-.21.08-.31l.75.44c-.03.1-.05.21-.08.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m55.49,61.93l-.75-.44c.03-.09.05-.18.08-.28l.75.44c-.03.09-.06.18-.08.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m55.57,61.65l-.75-.44c.03-.09.06-.17.09-.26l.75.44c-.03.08-.06.17-.09.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m55.66,61.4l-.75-.44c.03-.08.06-.16.1-.24l.75.44c-.03.08-.07.16-.1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m55.76,61.16l-.75-.44c.03-.08.07-.16.11-.23l.75.44c-.04.08-.07.16-.11.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m55.87,60.92l-.75-.44c.04-.08.08-.15.12-.23l.75.44c-.04.08-.08.15-.12.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m55.99,60.69l-.75-.44c.04-.08.08-.15.13-.23l.75.44c-.04.08-.09.15-.13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m56.11,60.46l-.75-.44c.05-.08.09-.15.14-.23l.75.44c-.05.08-.09.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m56.25,60.23l-.75-.44c.05-.08.1-.16.16-.23l.75.44c-.05.08-.11.15-.16.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m56.41,60l-.75-.44c.06-.08.12-.16.18-.24l.75.44c-.06.08-.12.16-.18.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m56.59,59.75l-.75-.44c.07-.09.14-.18.22-.27l.75.44c-.08.09-.15.18-.22.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m56.81,59.49l-.75-.44c.1-.11.19-.21.3-.31l.75.44c-.1.1-.2.2-.3.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m57.1,59.17l-.75-.44c.28-.28.59-.52.9-.7l.75.44c-.32.18-.62.42-.9.7"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m58.01,58.47c1.49-.86,2.7-.16,2.7,1.55s-1.2,3.79-2.69,4.65-2.71.18-2.71-1.54,1.2-3.8,2.69-4.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m57.96,43.25l-.75-.44c.76-.44,1.5-.81,2.23-1.11l.75.44c-.73.3-1.48.67-2.23,1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m60.2,42.14l-.75-.44c.64-.27,1.27-.48,1.88-.65l.75.44c-.61.17-1.24.38-1.88.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m62.07,41.49l-.75-.44c.48-.13.94-.23,1.4-.3l.75.44c-.46.07-.93.17-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m63.48,41.19l-.75-.44c.4-.06.8-.1,1.19-.12l.75.44c-.39.02-.78.06-1.19.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m64.67,41.07l-.75-.44c.36-.02.71-.01,1.06,0l.75.44c-.34-.02-.7-.02-1.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m65.72,41.08l-.75-.44c.33.02.65.06.96.11l.75.44c-.31-.05-.64-.09-.96-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m66.69,41.2l-.75-.44c.31.05.6.12.9.21l.75.44c-.29-.08-.59-.15-.9-.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m67.58,41.4l-.75-.44c.29.08.57.18.84.3l.75.44c-.27-.11-.55-.21-.84-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m68.42,41.7l-.75-.44c.28.12.54.25.8.39l.75.44c-.26-.15-.53-.28-.8-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m69.22,42.09l-.75-.44s.06.03.09.05l.75.44s-.06-.03-.09-.05"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m57.96,41.75l-.75-.44c.82-.47,1.63-.87,2.42-1.2l.75.44c-.79.33-1.6.73-2.42,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m60.37,40.55l-.75-.44c.69-.29,1.37-.52,2.03-.7l.75.44c-.66.18-1.34.41-2.03.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m62.41,39.85l-.75-.44c.52-.14,1.02-.25,1.52-.32l.75.44c-.5.08-1,.18-1.52.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m63.92,39.52l-.75-.44c.44-.07.87-.11,1.29-.13l.75.44c-.42.02-.85.06-1.29.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m65.21,39.39l-.75-.44c.39-.02.77-.01,1.14,0l.75.44c-.37-.02-.75-.03-1.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m66.35,39.4l-.75-.44c.36.02.7.06,1.04.12l.75.44c-.34-.06-.69-.1-1.04-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m67.4,39.53l-.75-.44c.33.06.65.13.97.22l.75.44c-.31-.09-.64-.17-.97-.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m68.36,39.75l-.75-.44c.31.09.62.2.91.32l.75.44c-.3-.12-.6-.23-.91-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m69.28,40.07l-.75-.44c.3.12.59.27.87.42l.75.44c-.28-.16-.57-.3-.87-.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m70.14,40.49l-.75-.44s.06.04.09.05l.75.44s-.06-.04-.09-.05"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m46.72,81.02l-.75-.44c-2.86-1.66-4.64-5.2-4.65-10.23,0-1.02.07-2.07.2-3.12l.75.44c-.14,1.06-.21,2.1-.2,3.12.01,5.03,1.79,8.57,4.65,10.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m42.27,67.67l-.75-.44c.09-.73.22-1.47.38-2.21l.75.44c-.16.74-.28,1.48-.38,2.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m42.65,65.46l-.75-.44c.13-.61.28-1.22.45-1.83l.75.44c-.17.61-.32,1.22-.45,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m43.1,63.63l-.75-.44c.15-.54.32-1.08.5-1.63l.75.44c-.18.54-.35,1.08-.5,1.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m43.59,62l-.75-.44c.17-.5.35-1.01.54-1.51l.75.44c-.19.5-.37,1-.54,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m44.13,60.49l-.75-.44c.18-.48.38-.96.59-1.43l.75.44c-.21.47-.4.95-.59,1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m44.72,59.06l-.75-.44c.2-.46.41-.93.63-1.38l.75.44c-.22.46-.43.92-.63,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m45.35,57.68l-.75-.44c.22-.46.45-.91.69-1.36l.75.44c-.24.45-.47.9-.69,1.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m46.04,56.32l-.75-.44c.24-.45.49-.9.75-1.34l.75.44c-.26.44-.51.89-.75,1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m46.79,54.98l-.75-.44c.27-.46.54-.91.82-1.35l.75.44c-.28.44-.56.89-.82,1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.61,53.63l-.75-.44c.3-.47.61-.93.92-1.38l.75.44c-.32.45-.62.91-.92,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m48.54,52.25l-.75-.44c.34-.49.7-.97,1.06-1.44l.75.44c-.36.47-.72.95-1.06,1.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m49.6,50.81l-.75-.44c.42-.54.85-1.07,1.29-1.58l.75.44c-.44.51-.88,1.04-1.29,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m50.89,49.24l-.75-.44c.56-.65,1.14-1.27,1.74-1.86l.75.44c-.6.59-1.18,1.21-1.74,1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m52.63,47.38l-.75-.44c1.67-1.64,3.46-3.05,5.33-4.13l.75.44c-1.87,1.08-3.66,2.49-5.33,4.13"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m57.96,43.25c8.81-5.09,15.97-1,16,9.12.03,10.12-7.09,22.45-15.9,27.54s-15.97,1-16-9.12c-.03-10.12,7.09-22.45,15.9-27.54Zm.06,21.43c1.49-.86,2.69-2.94,2.69-4.65s-1.21-2.41-2.7-1.55-2.7,2.95-2.69,4.67,1.22,2.4,2.71,1.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m45.79,82.61l-.75-.44c-3.1-1.8-5.02-5.63-5.03-11.07,0-1.1.07-2.23.22-3.38l.75.44c-.15,1.14-.22,2.27-.22,3.38.02,5.44,1.94,9.27,5.03,11.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m40.98,68.17l-.75-.44c.1-.79.24-1.59.41-2.39l.75.44c-.17.8-.31,1.6-.41,2.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m41.39,65.77l-.75-.44c.14-.66.3-1.32.49-1.98l.75.44c-.18.66-.35,1.32-.49,1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m41.87,63.79l-.75-.44c.16-.59.34-1.17.54-1.76l.75.44c-.2.59-.37,1.17-.54,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m42.41,62.03l-.75-.44c.18-.54.38-1.09.58-1.63l.75.44c-.21.54-.4,1.08-.58,1.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m43,60.41l-.75-.44c.2-.52.41-1.03.63-1.55l.75.44c-.22.51-.43,1.03-.63,1.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m43.63,58.86l-.75-.44c.22-.5.45-1,.69-1.5l.75.44c-.24.5-.47,1-.69,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m44.31,57.36l-.75-.44c.24-.49.49-.98.74-1.47l.75.44c-.26.48-.51.97-.74,1.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m45.06,55.89l-.75-.44c.26-.49.53-.97.81-1.45l.75.44c-.28.48-.55.96-.81,1.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m45.87,54.44l-.75-.44c.29-.49.58-.98.89-1.46l.75.44c-.31.48-.6.97-.89,1.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m46.76,52.98l-.75-.44c.32-.51.66-1,1-1.49l.75.44c-.34.49-.68.99-1,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m47.76,51.49l-.75-.44c.37-.53.75-1.05,1.15-1.56l.75.44c-.39.51-.78,1.03-1.15,1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m48.91,49.93l-.75-.44c.45-.58.92-1.15,1.4-1.71l.75.44c-.48.55-.95,1.12-1.4,1.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m50.31,48.22l-.75-.44c.61-.7,1.24-1.37,1.89-2.01l.75.44c-.65.64-1.28,1.31-1.89,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m52.19,46.22l-.75-.44c1.8-1.78,3.74-3.3,5.77-4.47l.75.44c-2.02,1.17-3.96,2.69-5.77,4.47"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m57.96,41.75c9.53-5.5,17.28-1.08,17.31,9.87s-7.67,24.29-17.2,29.79-17.28,1.08-17.31-9.87c-.03-10.95,7.67-24.29,17.2-29.79Zm.11,38.16c8.81-5.09,15.93-17.41,15.9-27.54-.03-10.12-7.19-14.2-16-9.12s-15.93,17.41-15.9,27.54c.03,10.12,7.19,14.2,16,9.12"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPump);
export default __webpack_public_path__ + "static/media/heat-pump.da5751690d50cfe9294d18c5d9211c02.svg";
export { ForwardRef as ReactComponent };